import React from 'react';
import { Box, Paper, Button, Typography, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useAuth0 } from '@auth0/auth0-react';
import { appVersion } from '../../utils/version';

function Login() {
  const { signIn } = useAuth();
  const { isLoading } = useAuth0();

  return (
    <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 400 }}>
        <Typography variant="h5" gutterBottom align="center">
          Connexion
        </Typography>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3 }}
            onClick={() => signIn()}
          >
            Se connecter avec Auth0
          </Button>
        )}
        <Typography variant="caption" sx={{ mt: 2, display: 'block', textAlign: 'center', color: 'text.secondary' }}>
          Version {appVersion}
        </Typography>
      </Paper>
    </Box>
  );
}

export default Login;
